export const reportDownload = {
  fileNotExist: "没有可下载的文件。",
  fileNotReady: "文件还未准备好,请稍后再试。",
  files: "{0}个文件",
  dataType: "数据类型",
  month: "月份",
  search: "查找",
  download: "批量下载",
  documentation: "文件",
  dataTypeName: {
    alert: "告警（含图片）",
    alertNoPic: "告警（不含图片）",
    driver: "操作员",
    fleet: "车间",
    vehicle: "设备",
    maintenance: "保养",
    repair: "维修",
    trip: "作业",
  },
};
